// extracted by mini-css-extract-plugin
export var acitonButtons = "_fi-0";
export var additionalIcon = "_fi-f";
export var block = "_fi-1";
export var blockContent = "_fi-7";
export var blockDescription = "_fi-8";
export var blockIcon = "_fi-9";
export var blockTitle = "_fi-6";
export var border = "_fi-a";
export var center = "_fi-l";
export var edge = "_fi-b";
export var edgeLabel = "_fi-c";
export var edgePath = "_fi-d";
export var error = "_fi-e";
export var flowchart = "_fi-g";
export var flowchartContent = "_fi-h";
export var highlighted = "_fi-3";
export var hover = "_fi-4";
export var icon = "_fi-i";
export var left = "_fi-m";
export var navButton = "_fi-j";
export var navButtons = "_fi-k";
export var right = "_fi-n";
export var selected = "_fi-2";
export var small = "_fi-5";